/**
 * Static filter option arrays — extracted from rates.component.ts
 */

export const RILA_BUFFER_OPTIONS: number[] = [1, 5, 10, 15, 20, 25, 30, 40, 90, 95, 100];
export const RILA_FLOOR_OPTIONS: number[] = [1, 2, 2.5, 3, 4, 5, 6, 7, 7.5, 8, 9, 10, 20, 50];
export const RILA_RATE_TYPE_OPTIONS: string[] = ['Cap', 'Par Rate', 'Spread', 'Fixed', 'Perf Trigger'];
export const RILA_PROTECTION_OPTIONS: string[] = ['Buffer Only', 'Floor Only', 'Both'];

export const AM_BEST_OPTIONS: string[] = ['A++', 'A+', 'A', 'A-', 'B++', 'B+', 'B', 'B-'];
export const RIDER_OPTIONS: string[] = ['DB', 'GMAB', 'GMIB', 'GMWB'];
/** Premium-type checklist.
 *
 *  The third option was labelled 'Periodic' until 2026-09-22. That was a
 *  misnomer: typeid 3 is "Single & Flexible" in the catalog, which is what
 *  /products has always called 'Both'. The two pages now agree on the label.
 *
 *  They do NOT agree on the semantics: /products treats 'Both' as a wildcard
 *  (selecting it keeps every row — see passesPremiumType there), while here it
 *  is a literal match on rows whose own type is typeid 3. Unify deliberately if
 *  ever asked; don't drift into it. */
export const PREMIUM_TYPE_OPTIONS: string[] = ['Single', 'Flexible', 'Both'];

/** 50 U.S. states, alphabetical. Renders in the main 5×10 grid. */
export const STATES_LIST: string[] = [
  'AK','AL','AR','AZ','CA','CO','CT','DE','FL','GA',
  'HI','IA','ID','IL','IN','KS','KY','LA','MA','MD',
  'ME','MI','MN','MO','MS','MT','NC','ND','NE','NH',
  'NJ','NM','NV','NY','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VA','VT','WA','WI','WV','WY'
];

/** Federal district + U.S. territories. Renders as a separate section
 *  below the 50 states because they have different sales/registration
 *  rules and are typically curated separately by carriers. */
export const TERRITORIES_LIST: string[] = ['DC','PR','GU','VI','AS','MP'];

/** Combined list — used wherever both should be filterable together. */
export const ALL_JURISDICTIONS_LIST: string[] = [...STATES_LIST, ...TERRITORIES_LIST];
